// import i18n, { Resource } from 'i18next';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend'; // Loads translations from /public/locales
import LanguageDetector from 'i18next-browser-languagedetector'; // Detects user language

import * as en from './assets/locales/en';
import * as ko from './assets/locales/ko';
import * as ja from './assets/locales/ja';

const resources = {
  'en': {
    ...en
  },
  'ko': {
    ...ko
  },
  'ja': {
    ...ja
  }
} as const;

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('lang')??'en',
    fallbackLng: {
      'en': ['en'],
      default: ['en']
    },
    debug: false,
    keySeparator: false,
    interpolation: {
      escapeValue: true,
    },
    react: {
      useSuspense: false,
    },
  });

i18n.languages = ['en'];

export default i18n;